import gsap from 'gsap';

const TILT = 5;
const SHIFT = 8;
const TITLE_SHIFT = { x: 14, y: 8 };

export default class HeroParallax {
  constructor() {
    this.hero = document.querySelector('.tournament__hero');
    this.image = this.hero?.querySelector('.tournament__hero-image');

    if (
      !this.image
      || !window.matchMedia('(hover: hover) and (pointer: fine)').matches
      || window.matchMedia('(prefers-reduced-motion: reduce)').matches
    ) {
      this.hero = null;
      return;
    }

    this.title = this.hero.querySelector('.tournament__title');
    this.onMove = this.onMove.bind(this);
    this.onLeave = this.onLeave.bind(this);

    gsap.set(this.image, { scale: 1.08, transformPerspective: 1000 });

    const quick = (target, prop) => gsap.quickTo(target, prop, { duration: 0.7, ease: 'power3.out' });

    this.image$ = {
      rotationX: quick(this.image, 'rotationX'),
      rotationY: quick(this.image, 'rotationY'),
      x: quick(this.image, 'x'),
      y: quick(this.image, 'y'),
    };
    this.title$ = this.title && { x: quick(this.title, 'x'), y: quick(this.title, 'y') };

    this.hero.addEventListener('pointermove', this.onMove);
    this.hero.addEventListener('pointerleave', this.onLeave);
  }

  move(nx, ny) {
    this.image$.rotationY(nx * TILT);
    this.image$.rotationX(-ny * TILT);
    this.image$.x(-nx * SHIFT);
    this.image$.y(-ny * SHIFT);
    this.title$?.x(nx * TITLE_SHIFT.x);
    this.title$?.y(ny * TITLE_SHIFT.y);
  }

  onMove(e) {
    const rect = this.hero.getBoundingClientRect();

    this.move((e.clientX - rect.left) / rect.width - 0.5, (e.clientY - rect.top) / rect.height - 0.5);
  }

  onLeave() {
    this.move(0, 0);
  }

  destroy() {
    if (!this.hero) {
      return;
    }

    this.hero.removeEventListener('pointermove', this.onMove);
    this.hero.removeEventListener('pointerleave', this.onLeave);
    gsap.killTweensOf([this.image, this.title]);
  }
}
